import { defineMessages } from 'react-intl';
export const messages = defineMessages({
  invalidPhone: {
    id: 'jutro-components.widgets.inputs.PhoneNumberField.invalid',
    defaultMessage: 'The provided phone number is not valid'
  }
});